import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { Button } from "@chakra-ui/react";
import { SearchFilter, SearchFilterType, TaskPriorityType } from "gql/graphql";
import { FlagOutlineIcon } from "modules/icons";

interface IProps {
  priorityType?: TaskPriorityType;
  newSearchFilters: SearchFilter[];
  setNewSearchFilters: React.Dispatch<React.SetStateAction<SearchFilter[]>>;
}

const FiltersDrawerTaskPriorityToggleButton = ({
  priorityType = TaskPriorityType.High,
  newSearchFilters,
  setNewSearchFilters,
}: IProps) => {
  const searchFilterType = SearchFilterType.TaskPriorityTypeList;

  const isToggled = newSearchFilters.some(
    (filter) =>
      filter.type === searchFilterType &&
      filter.stringListValue?.includes(priorityType),
  );

  const onClick = useCallback(() => {
    setNewSearchFilters((prev) => {
      const _filter = prev.find((filter) => filter.type === searchFilterType);
      const _prevTaskPriorityTypes = (_filter?.stringListValue ??
        []) as TaskPriorityType[];

      let nextValues: TaskPriorityType[] = [];
      if (isToggled) {
        nextValues = _prevTaskPriorityTypes.filter(
          (type) => type !== priorityType,
        );
      } else {
        nextValues = _prevTaskPriorityTypes.includes(priorityType)
          ? _prevTaskPriorityTypes
          : [..._prevTaskPriorityTypes, priorityType];
      }

      const newFilters = [...prev].filter(
        (filter) => filter.type !== searchFilterType,
      );

      if (nextValues.length > 0) {
        newFilters.push({
          type: searchFilterType,
          stringListValue: nextValues,
        });
      }
      return newFilters;
    });
  }, [isToggled, priorityType, searchFilterType, setNewSearchFilters]);

  return (
    <Button
      aria-label="unread"
      size="sm"
      variant="outline"
      rounded="full"
      leftIcon={<FlagOutlineIcon boxSize={4} fill={colors.gray50} />}
      backgroundColor={isToggled ? colors.blueLight : "transparent"}
      iconSpacing={1}
      px={2}
      fontSize={14}
      fontWeight={500}
      onClick={onClick}
    >
      Priority
    </Button>
  );
};

export default memo(FiltersDrawerTaskPriorityToggleButton);
